import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LoginService } from '../services/login.service';
import { ThemeSettingService } from '../services/theme-setting.service';
import { Toast, BodyOutputType, ToasterService } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-resend-verification',
  templateUrl: './resend-verification.component.html',
  styleUrls: ['./resend-verification.component.css']
})
export class ResendVerificationComponent implements OnInit {

  isEmptyEmail: boolean = false;
  submitted: boolean = false;
  isBusy:boolean = false;
  loaderConfig: any;

  constructor(
    private router:Router,
    private loginService:LoginService,
    public bsModalRef: BsModalRef,
    private toasterMessageService:ToasterMessageService,
    private toasterService:ToasterService,
    private themeSettingService: ThemeSettingService) { }

  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();
  }

  onDecline(): void {
    this.bsModalRef.hide();
  }

  onConfirm(email: string):void {
    if (email){
      this.isEmptyEmail = false;
      if (!this.submitted){
        this.submitted = true; // prevent form submit called twice
        this.resendVerification(email);
      }
    }
    else{
      this.isEmptyEmail = true;
    }
  }

  resendVerification(email:string) {
    this.isBusy = true;
    var param = new Array();
    param.push({ name: 'email', value: email });
    this.loginService.resendVerificationEmail(param).subscribe(result => {
      this.handleWorkflowReturn(result);
      this.isBusy = false;
    },
    error => {
      this.isBusy = false;
    });
  }

  handleWorkflowReturn(result: any): any {
    var command = JSON.parse(result);
      switch(command.ReturnType){
        case 0:
          if(command.Arguments){
            var path = [];
            command.Arguments.forEach(element => {
              path.push(element);
            });
            this.router.navigate(path);
          }
          break;
        case 1:
          this.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
          this.bsModalRef.hide();
          break;
      }
  }

  popToast(title: string, body: string, type:string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      }  
    };
    this.toasterService.pop(toast);
  }
}
